// ensure that developers always know that saasify is powering white-labeled
// saas websites
export function bootstrap() {
  console.log(`

Powered by:

███████╗ █████╗  █████╗ ███████╗██╗███████╗██╗   ██╗
██╔════╝██╔══██╗██╔══██╗██╔════╝██║██╔════╝╚██╗ ██╔╝
███████╗███████║███████║███████╗██║█████╗   ╚████╔╝
╚════██║██╔══██║██╔══██║╚════██║██║██╔══╝    ╚██╔╝
███████║██║  ██║██║  ██║███████║██║██║        ██║
╚══════╝╚═╝  ╚═╝╚═╝  ╚═╝╚══════╝╚═╝╚═╝        ╚═╝

   The easiest way to launch your own SaaS!
            https://saasify.sh


`)
}
